import styles from './Sidebar.module.css';

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import ToneLogo from '../../assests/images/tone-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { getMenu, getMenuByModule } from '../../slices/permissionSlice';
import { useTheme } from '../../contexts/ThemeContext';
import { useEffect, useMemo } from 'react';
import UserLogActivity from '../userActivity/UserActivity';
import { getAuthDetails } from '../../utils/helper';
import { CONSTANTS } from '../../utils/constants';
import { useNetworkStatus } from './InternetCheck';

const Sidebar = () => {
  const isOnline = useNetworkStatus();
  const navigate = useNavigate();
  const { colors, updateColors, isDarkMode } = useTheme();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const moduleUrl = location.pathname.split('/')[1];
  const { addUserActivity } = UserLogActivity();
  const menus = useSelector((state: RootState) => state.permission.selectedMenuList || []);

  const menuItems = useMemo(() => {
    const rawList = Array.isArray(menus?.data) ? [...menus.data] : [];
    if (moduleUrl === 'tone-admin') {
      const hasHierarchy = rawList.some((item) => item.slug === 'hierarchy');
      if (!hasHierarchy) {
        const companiesIdx = rawList.findIndex((item) => item.slug === 'companies');
        const hierarchyEntry = {
          id: 9991,
          moduleId: 5,
          name: 'Hierarchy',
          slug: 'hierarchy',
          isActive: true,
          logo: 'hierarchy.svg',
          tabOrder: '3.5',
          subModules: [],
        };
        if (companiesIdx !== -1) {
          rawList.splice(companiesIdx + 1, 0, hierarchyEntry);
        } else {
          rawList.push(hierarchyEntry);
        }
      }
    }
    return rawList;
  }, [menus, moduleUrl]);

  function getMenuName(menuName: string) {
    dispatch(getMenu(menuName));
    localStorage.setItem('menuName', menuName);
    addUserActivity(
      {},
      `Select ${menuName} menu`,
      `User navigated to menu: ${menuName}`,
      `${menuName}`,
    );
  }

  useEffect(() => {
    if (!isOnline) {
      localStorage.setItem('recentPath', location.pathname);
      navigate('/internet-connection');
    }
  }, [isOnline]);

  useEffect(() => {
    dispatch(getMenuByModule(moduleUrl));
    updateColors({
      ...colors,
      primary: getAuthDetails().user.primaryColor
        ? getAuthDetails().user.primaryColor
        : CONSTANTS.DEFAULT_PRIMARY_COLOR,
      secondary: getAuthDetails().user.secondaryColor
        ? getAuthDetails().user.secondaryColor
        : CONSTANTS.DEFAULT_SECONDARY_COLOR,
    });
  }, [moduleUrl, dispatch]);

  return (
    <div className={styles.sidebar}>
      <div className={styles.logoSection}>
        <img src={ToneLogo} className={styles.logo} alt="tone-logo" />
      </div>

      <ul className={styles.navList}>
        {menuItems.map((item: { slug: string; name: string; logo: string; id: number }) => (
          <li
            className={styles.navItem}
            onClick={() => getMenuName(item.name)}
            key={item.id}
          >
            <NavLink
              to={`/${moduleUrl}/${item.slug}`}
              className={`${styles.navLink} ${location.pathname === `/${moduleUrl}/${item.slug}` ? styles.active : ''}`}
            >
              <span className={styles.iconWrapper}>
                <span
                  className={styles.menuIcon}
                  style={{
                    maskImage: `url(/images/menus/${location.pathname === `/${moduleUrl}/${item.slug}` ? `selected-` : ``}${item.logo})`,
                    WebkitMaskImage: `url(/images/menus/${location.pathname === `/${moduleUrl}/${item.slug}` ? `selected-` : ``}${item.logo})`,
                  }}
                  aria-hidden="true"
                />
              </span>
              <span className={styles.menuText}>{item.name}</span>
            </NavLink>
          </li>
        ))}
        <hr className={styles.divider} />
      </ul>
    </div>
  );
};

export default Sidebar;
